import styled from 'styled-components';

import { setFontVariant } from '@similarweb/styles';

import { Button } from 'components/Button';

export const StyledRevealButton = styled(Button)`
  padding: 4px 12px;
  ${({ isLoading }) => isLoading && 'opacity: 1 !important;'}
`;

export const StyledInfoTooltipContent = styled.span`
  ${setFontVariant('tooltip')};

  font-weight: 700;
`;
